import { DownloadIcon } from "assets/icons";
import cn from "classnames";
import { Media } from "components";
import { MediaType } from "constants/enums";
import { onDownloadMediaArchive } from "helpers";
import { t } from "i18next";
import { useEffect, useState } from "react";
import { toast } from "react-hot-toast";
import { Button, LightBoxGallery } from "ui";

import { AlbumProps } from "./Album.types";

import styles from "./Album.module.scss";

const Album = ({ mediaList, className, extraActions }: AlbumProps) => {
  const [openedImageIndex, setOpenedImageIndex] = useState<number>();

  const [selectedMediaIndex, setSelectedMediaIndex] = useState(0);

  useEffect(() => {
    setSelectedMediaIndex(0);
  }, [mediaList]);

  const handleDownloadAll = async () => {
    try {
      await onDownloadMediaArchive(mediaList);
    } catch {
      toast.error(t("Failed to download images"));
    }
  };

  return (
    <>
      <div
        className={cn(styles.album, className)}
        data-testid="productInfo--album"
      >
        <div className={styles.album_nailsThumb}>
          {mediaList.map((mediaItem, index) => (
            <button
              key={mediaItem.id}
              className={cn(styles.album_nailItem, {
                [styles.album_nailItem__selected]: index === selectedMediaIndex
              })}
              onClick={() => setSelectedMediaIndex(index)}
            >
              <Media
                className={styles.album_nailImage}
                onClick={(e) => e.preventDefault()}
                mediaFile={mediaItem}
                withVideoLabel
              />
            </button>
          ))}
        </div>

        <div className={styles.album_activeImageThumb}>
          <Media
            className={styles.album_fullSizeMedia}
            mediaFile={mediaList[selectedMediaIndex]}
            autoPlay={false}
            onClick={(e) => {
              if (
                mediaList[selectedMediaIndex]?.mediaType !== MediaType.DOCUMENT
              ) {
                e.preventDefault();
                setOpenedImageIndex(selectedMediaIndex);
              }
            }}
            controls
          />
        </div>
      </div>

      <LightBoxGallery
        mediaList={mediaList}
        openedImageIndex={openedImageIndex}
        setOpenedImageIndex={setOpenedImageIndex}
      />
      <div className={styles.album_actions}>
        <Button
          variant="default"
          icon={<DownloadIcon />}
          onClick={handleDownloadAll}
        >
          {t("Download All")}
        </Button>
        {extraActions}
      </div>
    </>
  );
};

export default Album;
